export default __webpack_public_path__ + "static/media/img_15.50df13d7.jpg";